import { render, staticRenderFns } from "./AgeLocation.vue?vue&type=template&id=556da292&lang=pug"
import script from "./AgeLocation.vue?vue&type=script&lang=js"
export * from "./AgeLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports